var App = App || {};

App.SpeedBump = (function () {
    'use strict';

    const SPEEDBUMP_SELECTOR = "#SpeedBump";
    let triggeredByModal = null;

    // Initializes the speed bump modal for the given anchor
    const initialize = (anchor) => {

        const speedBumpElement = document.querySelector(SPEEDBUMP_SELECTOR);
        if (!speedBumpElement) return false;
        const speedBumpModal = new bootstrap.Modal(speedBumpElement);

        if (requiresSpeedBump(anchor)) {

            checkModalParent(anchor);
            setProceedButton(speedBumpElement, speedBumpModal, anchor);

            speedBumpElement.addEventListener('show.bs.modal', event => {
                anchor.focus();
                anchor.blur();
                triggeredByModal = App.SpeedBump.getTriggeredByModal();
                if (triggeredByModal) {
                    triggeredByModal.hide();
                }
            })

            speedBumpElement.addEventListener('hidden.bs.modal', event => {
                anchor.focus();
                anchor.blur();
                triggeredByModal = App.SpeedBump.getTriggeredByModal();
                if (triggeredByModal) {
                    triggeredByModal.show();
                }
                App.SpeedBump.setTriggeredByModal(null);
            })

            speedBumpModal.show();
            return true;
        }
        return false;
    }


    // Determines if the speed bump modal is required for the anchor
    const requiresSpeedBump = (anchor) => {

        try {
            const url = new URL(anchor.getAttribute("href"));
            const href = url.href;
            const hostname = url.hostname;

            const isExempt = typeof SpeedbumpData !== 'undefined' ? [...SpeedbumpData.ExemptList] : [];
            const isUriSchema = App.Helpers.isUriSchema(href);

            if (hostname === location.hostname || isExempt.indexOf(hostname) !== -1 || isUriSchema)
                return false;

            return true;
        }
        catch (e) {
            return false;
        }
    };

    // Sets the proceed button behavior in the speed bump modal
    const setProceedButton = (speedBumpElement, speedBumpModal, anchor) => {

        const href = anchor.getAttribute("href");
        const proceedButton = speedBumpElement.querySelector("button[data-speedbump='proceed']");

        proceedButton.onclick = () => {
            speedBumpModal.hide();
            window.open(href);
        };
    };

    // Checks if the anchor is inside another modal or offcanvas and stores its instance
    const checkModalParent = (anchor) => {

        let parentModalInstance;
        const parentModelElement = anchor.closest(".modal, .offcanvas");
        if (!parentModelElement) return;


        if (parentModelElement.classList.contains("modal")) {
            parentModalInstance = bootstrap.Modal.getInstance(parentModelElement);
        }
        else if (parentModelElement.classList.contains("offcanvas")) {
            parentModalInstance = bootstrap.Offcanvas.getInstance(parentModelElement);
        }

        App.SpeedBump.setTriggeredByModal(parentModalInstance);
    };

    return {
        initialize,
        getTriggeredByModal: () => triggeredByModal,
        setTriggeredByModal: (val) => { triggeredByModal = val; }
    };

})();